<template>
  <v-container
    fill-height
    :class="{ 'pa-4': xsOnly, 'pa-8': smAndUp }">
    <v-layout
      column
      align-center
      justify-center>
      <v-flex xs12 :class="{ 'max-width-450': smAndUp }">
        <v-layout column>
          <v-form ref="form" class="text-center">
            <logo class="image" style="max-width: 200px;" />
            <p class="reference text-left">{{ $t('login.input_reference') }}</p>
            <v-text-field
              v-model="locator"
              outlined
              :label="$t('fields.reference')"
              color="accent"
              :rules="[rules.required]"
              :error="loginError"
              :error-messages="loginError && state.formErrors ? state.formErrors.locator : []"
              v-on:keyup.enter.prevent="signIn()"
              @input="$store.commit('state/setFormErrors', null)"
              @keydown.space.prevent
            />
            <v-text-field style="display: none;" />
            <v-alert :value="auth.hasURLLoginFailed" type="error" transition="scale-transition">{{ $t('login.error.query_login_failed') }}</v-alert>
            <div class="nick-link font-weight-light mb-6 text-left" @click="show = true">{{ $t('login.find_reference') }}</div>
            <v-dialog v-model="show" max-width="800" :fullscreen="xsOnly" class="pa-2">
              <v-card class="pa-4">
                <v-layout justify-end class="top-sticky white-background">
                  <v-btn icon fab small @click="show = false" color="accent" :class="xsOnly ? 'mt-2 mr-2' : null">
                    <v-icon large>close</v-icon>
                  </v-btn>
                </v-layout>
                <v-card-text>
                <v-layout wrap>
                  <p class="title text-center mb-6">{{ $t('login.find_locator') }}</p>
                  <v-flex xs12 sm6>
                    <v-layout column align-center justify-space-between class="pa-6 full-height">
                      <img src="@/assets/pdf_qr_locator.png" class="dialog-image max-width-available" :alt="$t('login.pdf_image_alt')">
                    </v-layout>
                  </v-flex>
                  <v-flex xs12 sm6>
                    <v-layout column align-center justify-space-between class="pa-6 full-height">
                      <img src="@/assets/ticket_qr_locator.png" class="dialog-image max-width-available" style="max-height: 400px;" :alt="$t('login.ticket_image_alt')">
                    </v-layout>
                  </v-flex>
                </v-layout>
                </v-card-text>
              </v-card>
            </v-dialog>
            <main-button
              :text="$t('actions.sign_in')"
              :loading="state.loading"
              @click="signIn()"
            />
            <v-layout column align-center>
              <v-icon large class="mt-8 mb-4">qr_code</v-icon>
              <span class="grey--text darken-4 text-xs-center">{{ $t('login.or_scan_qr') }}</span>
            </v-layout>
          </v-form>
        </v-layout>
      </v-flex>
      <div class="text-center caption grey--text pt-2">v{{pjson.version}}</div>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import vuetifyMixins from '@/mixins/Vuetify'
import pjson from '@/../package.json'

export default {
  data () {
    return {
      rules: {
        required: (v) => !!v || this.$t('error.form.required')
      },
      locator: null,
      loginError: false,
      show: false,
      pjson
    }
  },
  computed: {
    ...mapState(['auth', 'state'])
  },
  methods: {
    signIn () {
      this.$store.commit('auth/setURLLoginFailed', false)
      if (this.$refs.form.validate()) {
        this.$store.dispatch('auth/signIn', this.locator.trim()).catch(() => {
          this.loginError = true
        })
      }
    }
  },
  components: {
    MainButton: () => import('@/components/app-components/MainButton.vue'),
    Logo: () => import('@/components/app-components/Logo.vue')
  },
  mixins: [
    vuetifyMixins
  ]
}
</script>

<style lang="scss" scoped>
.image {
  width: -webkit-fill-available;
  margin-bottom: 54px;
  max-width: 100%;
}
.reference {
  font-weight: 500;
  font-size: 16px;
}
</style>
